import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from 'reactstrap';
import SimpleBar from "simplebar-react";
import { menuItems } from '../../Layouts/navItems'; // Import menuItems

const SearchOption = () => {
    const [value, setValue] = useState("");
    const navigate = useNavigate();

    const onChangeData = (value) => {
        setValue(value);
    };

    useEffect(() => {
        const searchOptions = document.getElementById("search-close-options");
        const dropdown = document.getElementById("search-dropdown");
        const searchInput = document.getElementById("search-options");

        const handleFocus = () => {
            const inputLength = searchInput.value.length;
            if (inputLength > 0) {
                dropdown.classList.add("show");
                searchOptions.classList.remove("d-none");
            } else {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        };

        const handleKeyUp = () => {
            const inputLength = searchInput.value.length;
            handleFocus();
        };

        const handleClose = () => {
            searchInput.value = "";
            dropdown.classList.remove("show");
            searchOptions.classList.add("d-none");
        };

        const handleClickOutside = (e) => {
            if (e.target.getAttribute('id') !== "search-options") {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        };

        searchInput.addEventListener("focus", handleFocus);
        searchInput.addEventListener("keyup", handleKeyUp);
        searchOptions.addEventListener("click", handleClose);
        document.body.addEventListener("click", handleClickOutside);

        return () => {
            searchInput.removeEventListener("focus", handleFocus);
            searchInput.removeEventListener("keyup", handleKeyUp);
            searchOptions.removeEventListener("click", handleClose);
            document.body.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const filteredMenuItems = menuItems.reduce((acc, item) => {
        // if (item.label && typeof item.label === 'string' && value) {
        //     if (item.label.toLowerCase().includes(value.toLowerCase())) {
        //         acc.push(item);
        //     }
        // }

        if (item.subItems) {
            item.subItems.forEach(subItem => {
                if (subItem.label && typeof subItem.label === 'string' && value) {
                    if (subItem.label.toLowerCase().includes(value.toLowerCase()) || item.label.toLowerCase().includes(value.toLowerCase())) {
                        acc.push({
                            ...subItem,
                            icon: item.icon, // Mantém o ícone do pai
                            label: `${item.label} > ${subItem.label}` // Concatena o nome do pai
                        });
                    }
                }
            });
        }

        return acc;
    }, []);


    const handleMenuItemClick = (link) => {
        navigate(link);
    };

    return (
        <React.Fragment>
            <form className="app-search d-none d-md-block">
                <div className="position-relative">
                    <Input type="text" className="form-control" placeholder="Buscar Menu..."
                           id="search-options"
                           value={value}
                           onChange={e => {
                               onChangeData(e.target.value);
                           }} />
                    <span className="mdi mdi-magnify search-widget-icon"></span>
                    <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                          id="search-close-options"></span>
                </div>
                <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                    <SimpleBar style={{ height: "320px" }}>
                        {filteredMenuItems.length > 0 ? (
                            filteredMenuItems.map(item => (
                                <Link
                                    key={item.id || item.label} // Use item.id if available, otherwise use label
                                    to={item.link}
                                    className="dropdown-item notify-item"
                                    onClick={() => handleMenuItemClick(item.link)}
                                >
                                    <i className={`${item.icon} align-middle fs-18 text-muted me-2`}></i>
                                    <span>{item.label}</span>
                                </Link>
                            ))
                        ) : (
                            <div className="dropdown-header">
                                <h6 className="text-overflow text-muted mb-0 text-uppercase">Menu não encontrado</h6>
                            </div>
                        )}
                    </SimpleBar>
                </div>
            </form>
        </React.Fragment>
    );
};

export default SearchOption;